  /**
   * Maps the given education level string to its corresponding Portuguese translation.
   *
   * @param level - The education level in English. Possible values are "elementary", "highSchool", and "college".
   * @returns The corresponding Portuguese translation of the education level. If the level is not recognized, it returns the original level string.
   */
  export const mapEducationLevel = (level: string) => {
    const mapping: { [key: string]: string } = {
      elementary: "Ensino Fundamental",
      high_school: "Ensino Médio",
      college: "Ensino Superior",
    };
    return mapping[level] || level;
  };

  /**
   * Maps the difficulty level from English to Portuguese.
   *
   * @param level - The difficulty level in English. Possible values are "easy", "medium", and "hard".
   * @returns The corresponding difficulty level in Portuguese. If the level is not recognized, it returns the original level.
   */
  export const mapDifficultyLevel = (level: string) => {
    const mapping: { [key: string]: string } = {
      easy: "Fácil",
      medium: "Médio",
      hard: "Difícil",
    };
    return mapping[level] || level;
  };